<template>
	<div>
		<table class="table table-bordered mt-4">
			<tr>
				<td></td>
				<td>
					<strong>Task</strong>
				</td>
				<td>
					<strong>Deadline</strong>
				</td>
				<td>
					<strong>Assegnato a</strong>
				</td>
				<td>
					<strong>Assegnato da</strong>
				</td>
			</tr>
			<tr v-for="(t, index) in taskListData"
			    :key="index">
				<td>
					<a href="#"
					   :style="strikeOrNot(t.done)"
					   @click.prevent="teamTaskChangeStatus({id:t.id})">
						<i class="fa-check-circle"
						   :class="t.done === 1 ? 'fas' : 'far'"
						   :style="t.done === 1 ? 'color:green' : ''"></i>
					</a>
				</td>
				<td style="max-width: 300px">
					<span style="word-break: break-word">
						<span :style="strikeOrNot(t.done)">{{t.description}}</span>
					</span>
				</td>
				<td nowrap>
					<span :style="strikeOrNot(t.done)">
						{{t.scadenza}} &nbsp;&nbsp;<a :href="`/custom/${t.risorsa_id}/${t.operazione_id}`"
						   :style="strikeOrNot(t.done)"
						   target="_blank">
							 <i class="fas fa-external-link-alt"></i>
						</a>
					</span>
				</td>
				<td>
					<span :style="strikeOrNot(t.done)">
						{{t.task_appointee_name || t.task_appointee_email}}
					</span>
				</td>
				<td>
					<span :style="strikeOrNot(t.done)">
						{{t.task_assignee_name || t.task_assignee_email}}
					</span>
				</td>
			</tr>
		</table>
	</div>
</template>
<script>
	import { mapActions } from 'vuex'

	export default {
		props: {
			userInAssistance: {
				type: Object,
				required: false,
			},

			taskListData: {
				type: Array,
				required: false,
			},
		},

		methods: {
			strikeOrNot(done) {
				return done === 1 ? 'text-decoration: line-through; color: grey' : 'color: rgba(0,0,0,.87)'
			},
			...mapActions('n_supercoach', ['teamTaskChangeStatus']),
		},
	}
</script>